/**
 * Bundled sample NOFO — pre-extracted PEPFAR opportunity used by the
 * onboarding sample replay (design/ONBOARDING_SPEC.md Beat 2).
 *
 * Content mirrors SAMPLE_PEPFAR_DATA in server.js (the same sample served
 * by /api/extract-sample) reshaped into the extraction output schema so it
 * renders through the normal ExtractionTable card. The replay is entirely
 * client-side: zero Gemini call, zero quota decrement, works with the
 * backend cold or unreachable.
 */

export const SAMPLE_NOFO_META = {
  title:  "PEPFAR FY2025 — Community HIV Prevention & Treatment Continuity",
  funder: "U.S. President's Emergency Plan for AIDS Relief (PEPFAR) / USAID",
  label:  "Sample NOFO (bundled)",
};

export const SAMPLE_NOFO_DATA = {
  _classification: {
    primary: "Government/Multilateral Grant",
    secondary: "Cooperative Agreement",
  },
  _confidence: "High",
  _isSample: true,
  opportunityIdentification: {
    opportunityId: "Not specified",
    callTitle: "PEPFAR FY2025 — Community HIV Prevention & Treatment Continuity",
    callReference: "Not specified",
    funderName: "U.S. President's Emergency Plan for AIDS Relief (PEPFAR) / USAID",
    programName: "PEPFAR Community HIV Programming",
    fundingInstrumentType: "Cooperative Agreement",
    sourceUrl: "Not specified",
  },
  programDescription: {
    abstract: "Cooperative agreement supporting community-based organizations in strengthening HIV prevention, testing, and treatment continuity. Priority areas include differentiated service delivery, viral load suppression, and reaching the final 10% of undiagnosed PLHIV.",
    focusAreas: ["HIV/AIDS prevention", "Treatment adherence", "Community health systems", "Key populations", "PMTCT"],
    geographicFocus: ["Kenya", "Uganda", "Tanzania", "Nigeria"],
    targetBeneficiaries: "People living with HIV, key populations, and communities served by community-based organizations in Sub-Saharan Africa",
  },
  fundingParameters: {
    awardMin: "$2,500,000",
    awardMax: "$5,000,000",
    currency: "USD",
    numberOfAwards: "Not specified",
    totalFundingAvailable: "Not specified",
    costShareRequired: "Not specified",
    allowableCosts: [],
    disallowedCosts: [],
    indirectCostAllowed: "Not specified",
    indirectCostCap: "Not specified",
  },
  eligibility: {
    organizationalEligibility: ["US NGOs", "Local NGOs with ≥5 years HIV programming experience"],
    geographicEligibility: ["Sub-Saharan Africa (Kenya, Uganda, Tanzania, Nigeria)"],
    individualEligibility: [],
    restrictedToExistingGrantees: false,
    partnershipRequired: false,
    minimumExperienceYears: "5 years HIV programming in target country",
    requiredRegistrations: ["Active SAM registration with valid UEI"],
  },
  timeline: {
    loiDeadline: "Not specified",
    applicationDeadline: "2025-09-15",
    qnaDeadline: "Not specified",
    awardAnnouncementDate: "Not specified",
    projectStartDate: "Not specified",
    projectDurationMonths: "36 months",
    keyDates: [],
  },
  applicationProcess: {
    submissionPortal: "Grants.gov",
    submissionMethod: "Online portal",
    applicationStages: [],
    requiredDocuments: [
      "Technical Approach (30-page max)",
      "Past Performance narrative",
      "Key Personnel CVs",
      "Budget Narrative",
      "Org Capacity Statement",
    ],
    pageLimits: "Technical Approach: 30 pages max",
    budgetTemplateRequired: false,
    applicationLanguage: "Not specified",
  },
  evaluationCriteria: {
    qualifyingCriteria: [
      "Minimum 5 years HIV programming in target country",
      "Active SAM registration with valid UEI",
    ],
    technicalCriteria: [
      "Demonstrated M&E capacity (PEPFAR MER indicators, DATIM reporting)",
      "Existing community health worker networks",
    ],
    financialCriteria: "Not specified",
  },
  complianceAndRisks: {
    irbRequired: false,
    dataProtectionRequirements: [],
    registrationRequirements: ["SAM/UEI"],
    reportingRequirements: ["PEPFAR MER indicators", "DATIM reporting"],
    performanceIndicators: ["PEPFAR MER indicators", "DATIM reporting"],
    brandingRequirements: "Not specified",
    sourceConflicts: [],
  },
  contactsAndLinks: {
    pointOfContact: "Not specified",
    email: "pepfar-partnerships@usaid.gov",
    phone: "Not specified",
    applicationUrl: "Not specified",
    faqUrl: "Not specified",
  },
  notes: {
    specialRequirements: "Prior PEPFAR partnership preferred.",
    restrictions: "Not specified",
    additionalNotes: "This is a bundled sample extraction for demonstration. Field values are from a representative PEPFAR opportunity snapshot.",
  },
};

/* Replay pacing — staged progress the onboarding replay walks through
   (~9s total; rendered instantly under prefers-reduced-motion). */
export const SAMPLE_REPLAY_STAGES = [
  { percent: 8,   message: "Reading document…",             delay: 0    },
  { percent: 24,  message: "Reading document…",             delay: 1200 },
  { percent: 42,  message: "Extracting fields…",            delay: 2600 },
  { percent: 61,  message: "Extracting fields…",            delay: 4400 },
  { percent: 78,  message: "Extracting fields…",            delay: 6200 },
  { percent: 92,  message: "Formatting…",                   delay: 7600 },
  { percent: 100, message: "Formatting…",                   delay: 8600 },
];
